/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, hour24 } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './WeeklySlotForm.css';

import {
} from '../../actions';

let dayOfWeekOptions = [
  [0, 'Sunday'],
  [1, 'Monday'],
  [2, 'Tuesday'],
  [3, 'Wednesday'],
  [4, 'Thursday'],
  [5, 'Friday'],
  [6, 'Saturday'],
];


class WeeklySlotForm extends OzFormComponent {

  static fields = [
    'scheduleId',
    'dayOfWeek',
    'hour',
    'minute',
  ];

  renderPreview() {
    let room = this.props.room;
    if (!room) return;

    let hour = this.state.hour;
    let minute = this.state.minute;
    let dayOfWeek = this.state.dayOfWeek;
    if (!hour || !minute || !dayOfWeek) return;

    let startMoment = moment().hour(hour).minute(minute);
    let endMoment = moment(startMoment);
    endMoment.add(room.minutes, 'minutes');

    let prettyStart = startMoment.format('h:mma');
    let prettyEnd = endMoment.format('h:mma');

    return (
      <div className="preview">
        {prettyStart}-{prettyEnd}
      </div>
    )
  }

  renderBody() {
    let hourOptions = [];
    for (let i = 0; i < 24; i++) {
      hourOptions.push([i, hour24(i)]);
    }

    let minuteOptions = [];
    for (let i = 0; i < 60; i += 5) {
      let pretty = i;
      if (i < 10) pretty = '0' + i; 
      minuteOptions.push([i, pretty]);
    }

    return (
      <div className="WeeklySlotForm">
        {this.renderFormGroup('Day of week', 'select', 'dayOfWeek', dayOfWeekOptions)}
        {this.renderFormGroupPair(
          ['Start Time Hour', 'select', 'hour', hourOptions],
          ['Minute', 'select', 'minute', minuteOptions])}

        {this.renderPreview()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WeeklySlotForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/WeeklySlotForm.js
 **/